<template>
    <div>
        <section class="content gray">
            <div class="container pt-5">
                <span class="left-aligned-title">Notification</span>
            </div>
        </section>

        <section class="mail_list">
            <section class="content">
                <div class="container inbox-table">

            <table class="table inbox-hover">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <!--unread-->
                    <tr
                        v-bind:class="[notification.notification_status == 'unread' ? activeClass : inactiveClass]"
                        v-for="notification in notification_list"
                        :key="notification.id"
                        >
                        <td><b>{{ notification.title }}</b></td>
                        <td>{{ notification.receive_date }}</td>
                    </tr>
                </tbody>
            </table>
            <paginate
              v-if="notificationListFrom.totalPage > 1"
              :page-count="notificationListFrom.totalPage"
              :containerClass="'pagination'"
              :click-handler="clickCallback"
              :prev-text="'Prev'"
              :next-text="'Next'">

                 <span slot="prevContent">previous</span>
                 <span slot="nextContent">nexts</span>
                 <span slot="breakViewContent">
                   <svg width="16" height="4" viewBox="0 0 16 4">
                     <circle fill="#999999" cx="2" cy="2" r="2" />
                     <circle fill="#999999" cx="8" cy="2" r="2" />
                     <circle fill="#999999" cx="14" cy="2" r="2" />
                   </svg>
                 </span>
            </paginate>
        </div>
        </section>
    </section>
    </div>

</template>

<script>

import axios from 'axios'
import VueAdsPagination from 'vue-ads-pagination';

export default {
  // Note: data-name, data-enotification and data-mobile becomes camel case in props
  props: [
    "dataTotalPage",
    "dataUserId",
    "dataActionUrl",
    "dataDetailUrl",
    "dataImageUrl",
    "dataCount",
    "dataMember"
  ],
  data() {
    return {
        activeClass:'highlight',
        inactiveClass:'read',
        count: this.dataCount,
        member: this.dataMember,
        actionUrl: this.dataActionUrl,
        detailUrl: this.dataDetailUrl,
        messageImage: this.dataImageUrl+'/icon_message.svg',
        deleteImage: this.dataImageUrl+'/icon_garbage.svg',

        notificationListFrom: {
            userId: this.dataUserId,
            totalPage: parseInt(this.dataTotalPage),
            currentPage: 1,
            notificationStatus: 'all',
            keyword: ''
        },
        notification_list:[]
    };
  },
    mounted() {
        this.getnotificationList('all',1);
    },
    components: {
        VueAdsPagination,
    },
    methods: {
         getnotificationList(notificationStatus, page)
         {
             //assign notification status
             if(notificationStatus)
             {
                  this.notificationListFrom.status = notificationStatus;
             } else {
                  this.notificationListFrom.status = 'all';
             }
             //assign page
             if(page)
             {
                 this.notificationListFrom.currentPage = parseInt(page);
             } else {
                  this.notificationListFrom.currentPage = 1;
             }

             axios.post(this.actionUrl, this.notificationListFrom).then(response => {
                     this.notification_list = response.data.data;
                     this.updateStatusForm.selectedId = [];
               }).catch(error => {
                   console.log(error.response);
              });
         },
         notificationAction(notificationStatus)
         {
              let url = this.detailUrl+'/inbox_notification_action';

             if(this.updateStatusForm.selectedId.length < 1)
             {
                 Swal.fire({
                   type: "warning",
                   title: "Failure",
                   text: "No notification was selected"
                 });
             } else {
                 this.updateStatusForm.notificationStatus = notificationStatus;

                 axios.post(url, this.updateStatusForm).then(response => {
                      console.log(response.data.message);
                         if(response.data.message == "Success")
                         {
                            Swal.fire({
                               type: "success",
                               title: "Change Status",
                               text: "Selected notification change to "+notificationStatus
                           }).then(() => {
                            this.getnotificationList(this.notificationListFrom.notificationStatus, 1);
                           });
                         }
                   }).catch(error => {
                       console.log(error.response);
                  });
             }
         },
         clickCallback: function(pageNum) {
              this.getnotificationList(this.notificationListFrom.notificationStatus, pageNum);
         },
         check: function(e) {
             $('tbody tr').removeClass("highlight");

             $('tbody td:first-child input').change(function () {
                 $(this).closest('tr').toggleClass("highlight", this.checked);
             });
        }
    }
};
</script>
